import { useShowContext } from 'framework/show';
import { useAuthorization } from 'framework/authorization';
import { ActivityType } from 'domain/shared/timeline';
import React from 'react';
import { FormFieldsData } from 'framework/form';
import { COMPANY_UPDATE_SERVICE_NOTES } from 'domain/shared/core/permissions';
import { CANDIDATE_TIMELINE_RECORDS_ALIAS } from 'domain/shared/candidate';

export const TimelineType: any = {
  ...ActivityType,
  NOTE: 'Note',
  FEEDBACK: 'Feedback',
  RESUME: 'Resume',
};

const useTimelineLayoutHelper = ({ isShowButtons }: { isShowButtons?: (data: FormFieldsData) => boolean } = {}) => {
  const { data } = useShowContext();
  const createdById = data.getValueBySource('createdById');
  const isInstantFeedback = data.getValueBySource('isInstantFeedback');
  const isProjectStatus = data.getValueBySource('projectStatusType');
  const isScrappedEmailActivity =
    data.getValueBySource('activityType') === 'EMAIL' && data.getValueBySource('internetMessageId') != null;
  const isScrappedOfferActivity =
    data.getValueBySource('type') === CANDIDATE_TIMELINE_RECORDS_ALIAS.OFFER &&
    data.getValueBySource('authorId') != null;
  const { isGranted } = useAuthorization();

  const canUpdateServiceNote = isGranted(COMPANY_UPDATE_SERVICE_NOTES);
  const getButtons = (buttons: React.ReactElement[]) => {
    const isShow = isShowButtons
      ? isShowButtons(data.getData())
      : (isScrappedOfferActivity ||
          isScrappedEmailActivity ||
          !!isProjectStatus ||
          (createdById === null && canUpdateServiceNote) ||
          createdById != null) &&
        !isInstantFeedback;

    return isShow
      ? buttons.filter(button => {
          const { permissionToCheck } = button.props;
          return !permissionToCheck || isGranted(permissionToCheck);
        })
      : [];
  };

  return {
    getButtons,
  };
};

export default useTimelineLayoutHelper;
